module.exports = __webpack_public_path__ + "static/media/colabs-portfolio_07.5388a76b.jpg";